// components/NewsCard.tsx
import React from "react";
import { News } from "../models/News";
import "../styles/news.css";

type Props = {
    news: News;
    onOpen: (id: number) => void;
};

export const NewsCard: React.FC<Props> = ({ news, onOpen }) => {
    return (
        <div className="news-card" onClick={() => onOpen(news.id)}>
            <div
                className="news-card-image"
                style={{ backgroundImage: `url(${news.photoUrl})` }}
            />

            <div className="news-card-content">
                <div className="news-card-date">
                    {news.dateCreated.toLocaleDateString("ru-RU")}
                </div>

                <h3 className="news-card-title">{news.title}</h3>

                <p className="news-card-short">
                    {news.shortDescription}
                </p>

                <div className="news-card-link">Читать →</div>
            </div>
        </div>
    );
};
